/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createHomeStyles = makeStyles(() =>
  createStyles({
    root: {},
    title: {
      margin: '20px 0 40px',
      textTransform: 'none',
    },
    info: {
      fontSize: '14px',
      lineHeight: '14px',
    },
  }),
);

export { createHomeStyles };
